import { headingBlue } from "../../assets/colors";

export const titleStyle = {
    backgroundColor: headingBlue,
    color: 'white',
    fontSize:'1rem',
    display: "flex",
    alignItems: 'center'
  }

export const bodyBoxstyle= {
    padding: "1rem 0.1rem 1rem 0.1rem"
}

export const bodyTitleStyle={
    fontSize:"0.9rem"
}

export const listTypoStyle = {
    fontsize: "0.9rem"
}